import { Descriptions } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getStudentCounselMenu } from "../../../api/studentsCounsel.api";
import useAxios from "../../../hooks/useAxios";
import { IClass } from "../../../models/campusClasses.model";
import { IStudent } from "../../../models/campusClasses2.model";
import { ICounselMenuResponse } from "../../../models/studentsCounsel.model";
import { ClassContents } from "../../../pages/tutor/class";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import CounselForm from "../../student/student/CounselForm";
import SelectClassStudentModal from "./modals/SelectClassStudentModal";

interface IProps {
  classData: IClass|undefined;
  setContent: (content: ClassContents) => void;
}

const CreateCounseling: FC<IProps> = ({
  classData,
  setContent,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<ICounselMenuResponse>();

  const [student, setStudent] = useState<IStudent>();
  const [selectClassStudentVisible, setSelectClassStudentVisible] = useState(false);

  useEffect(() => {
    execute(getStudentCounselMenu());
  }, []);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="comm-table__area rowType mt-2">
        <Descriptions
          bordered
          column={1}
          size="small"
          labelStyle={{
            width: '12.5%',
            textAlign: 'center',
          }}
        >
          <Descriptions.Item label={t('class.tutor.column20')}>
            <div className="comm-btn__area">
            <Button
              className='btn-basic small mint mr-1'
              onClick={() => setSelectClassStudentVisible(true)}
              text={t('common.button.select')}
            />
            <span className="v-line">{student?.memberKorName}</span>
            </div>
          </Descriptions.Item>
        </Descriptions>
      </div>

      <CounselForm
        formMode="create"
        setFormMode={() => {}}
        counsel={undefined}
        menus={res?.data ?? []}
        student={{
          studentCode: student?.memberCode,
          campusCode: student?.campusCode
        }}
        setContent={setContent}
      />

      {selectClassStudentVisible &&
        <SelectClassStudentModal
          visible={selectClassStudentVisible}
          setVisible={setSelectClassStudentVisible}
          classCode={classData?.classCode}
          setStudent={setStudent}
        />
      }
    </>
  );
}

export default CreateCounseling;
